<template>
  <div>
    <carouselSection />
    <main id="main">
      <contentSection />
    </main>
  </div>
</template>

<script>
/* eslint-disable */

import carouselSection from "./carouselSection";
import contentSection from "./contentSection";
export default {
  components: {
    carouselSection,
    contentSection
  }
};
</script>

<style lang="scss" scoped></style>
